import React from 'react'
import { Heading } from '@ui'
import { clsx } from 'clsx'

import { LetterStyles, LetterStylesVariantProps } from './IconInitials.css'

export const IconInitials = (props: {
    letterFontSize?: LetterStylesVariantProps
    children?: React.ReactNode
}) => (
    <Heading
        marketingFont
        className={clsx([
            LetterStyles(props.letterFontSize ? { fontSize: props.letterFontSize } : undefined),
        ])}
    >
        {props.children}
    </Heading>
)
